export function calculateCounterOrigin(hexCenter, counterSize) {
    return {
        x: hexCenter.x - counterSize / 2,
        y: hexCenter.y - counterSize / 2,
    };
}
export function getCounterSize(hexProperties) {
    return hexProperties.hasFlatTop ? hexProperties.height / 1.5 : hexProperties.width / 1.5;
}
